// src/context/DisplayModeContext.tsx
import React, { createContext, useContext, useState, ReactNode, useCallback } from 'react';

type DisplayMode = 'grid' | 'list';
const DEFAULT_DISPLAY_MODE: DisplayMode = 'grid';
const getNextDisplayMode = (currentMode: DisplayMode): DisplayMode =>
  currentMode === 'grid' ? 'list' : 'grid';

interface DisplayModeContextType {
  displayMode: DisplayMode;
  toggleDisplayMode: () => void;
}

const DisplayModeContext = createContext<DisplayModeContextType | undefined>(undefined);

interface DisplayModeProviderProps {
  children: ReactNode;
}

export const DisplayModeProvider: React.FC<DisplayModeProviderProps> = ({ children }) => {
  const [displayMode, setDisplayMode] = useState<DisplayMode>(DEFAULT_DISPLAY_MODE);

  const toggleDisplayMode = useCallback(() => {
    setDisplayMode(getNextDisplayMode);
  }, []);

  return (
    <DisplayModeContext.Provider value={{ displayMode, toggleDisplayMode }}>
      {children}
    </DisplayModeContext.Provider>
  );
};

export const useDisplayMode = () => {
  const context = useContext(DisplayModeContext);
  if (context === undefined) {
    throw new Error('useDisplayMode must be used within a DisplayModeProvider');
  }
  return context;
};
